module.exports = __webpack_public_path__ + "img/text-and-image-reverse.9fa5123a.svg";